module.exports = __webpack_public_path__ + "static/bg-talamus-de0a55490c1ea14262b48962a5c7af9a.png";